module.exports = __webpack_public_path__ + "img/single-file.c542406f.svg";